module.exports = __webpack_public_path__ + "img/lingqu.c375b9f4.png";